enum OcrDialogFields {
	OUTPUT_FORMAT = "output_format",
	LANGUAGE = "language",
	CHECK_RESOLUTION = "check_resolution",
	NORMALIZE_ROTATION = "normalize_rotation",
	FAIL_ON_WARNING = "fail_on_warning",
	JPEG_QUALITY = "jpeg_quality",
	DPI_ACTIVE = "dpi_active",
	DPI = "dpi",
	PDFA_FORMAT = "pdfa_format",
	PDFA_RESOLUTION = "pdfa_resolution",
	OPTIMIZE = "optimize",
	DESKEW = "deskew",
	DESPECKLE = "despeckle",
	DITHERING = "dithering",
	NOISE_REDUCTION = "noise_reduction",
	GAMMA_CORRECTION = "gamma_correction",
	INCREASE_CONTRAST = "increase_contrast",
	EDGE_ACCENTUATION = "edge_accentuation",
	SHARPEN = "sharpen",
	MEDIAN_FILTER = "median_filter",
	PAGE_FORMAT = "page_format",
	SIZE = "size",
	WIDTH = "width",
	HEIGHT = "height",
	ORIENTATION = "orientation",
	PREVIEW = "preview"
}

export default OcrDialogFields;